import React from 'react';
import BookingDetail from './BookingDetail';

const CustomerBookingDetail = () => {
  return <BookingDetail />;
};

export default CustomerBookingDetail;
